import { createApp } from 'vue'
import Axios from 'axios'
import vSelect from 'vue-select'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { PiniaSharedState } from 'pinia-shared-state'
import { Timeago } from 'vue2-timeago'
import VueGtag from "vue-gtag"
import VSwatches from 'vue3-swatches'
import { checkForUpdates, initializeAppVersion } from './utils/version'
import 'vue3-swatches/dist/style.css'
import '../public/assets/css/mdi.css'
import './assets/styles/dialog-styles.css'
import 'vuetify/styles'
import 'vue-skeletor/dist/vue-skeletor.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { Skeletor } from 'vue-skeletor'
import { DriverStore } from './pinia/Driver.js'

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'NightRiderz',
    themes: {
        NightRiderz: {
        dark: false,
        colors: {
          surface: "#1f2430"
        }
      }
    }
  }
})

import "vue-select/dist/vue-select.css"

// Initialiser la version de l'application
initializeAppVersion();

const app = createApp(App)
const pinia = createPinia()

pinia.use(
    PiniaSharedState({
        enable: true,
        initialize: true,
        type: 'localstorage',
    })
)

var AxiosCreate = Axios.create({baseURL: 'https://api.nightriderz.world/gateway.php?contentType=application/json'})

AxiosCreate.interceptors.request.use(function (config) {

    if(config.url == "") {
        config.headers['easharpptr-u'] = localStorage.getItem('easharpptr_u')
        config.headers['easharpptr-p'] = localStorage.getItem('easharpptr_p')
    }

    return config
  })

  if (import.meta.hot) {
    import.meta.hot.on(
      "vite:beforeUpdate",
      () => console.clear()
    );
  }


  function carClasshHash(rating) {
    switch (""+rating) {
        case "869393278" : return "F"
        case "872416321" : return "E"
        case "415909161" : return "D"
        case "1866825865" : return "C"
        case "-406473455" : return "B"
        case "-405837480" : return "A"
        case "-2142411446" : return "S"
        case "86241155": return "S1"
        case "221915816": return "S2"
        case "-543091316": return "X"
        default: return "O"
      }
  }

  GetUserInfo()

async function GetUserInfo() {
    try {
    const res = await AxiosCreate.post("", JSON.stringify({serviceName: "session",methodName: "GetUserInfo"}))
    const Driver = DriverStore()

    Driver.setPersona(res.data.persona)
    Driver.setUser(res.data.user)
    Driver.setCrew(res.data.crew)
    Driver.setCurrentCrew(res.data.crew.current)
    Driver.setOthers(res.data.others)
    Driver.setLogged(true)
    } catch(error) {

    }
    addrouterbefore()
}

function addrouterbefore() {
   router.beforeEach((to, from, next) => {

    const Driver = DriverStore()
    if(to.meta.requireAuth && !Driver.logged) {
      Driver.showDrawerAuth(true, to.fullPath)
    } else {
      if(to.path != "/")
        document.querySelector('title').innerText = to.name + " - NightRiderz"
      else
        document.querySelector('title').innerText = "NightRiderz"
    
      window.scrollTo({ top: 0, behavior: 'smooth' })
      
      next()
    }
    
    
    })
  }
  
app.use(router)
app.use(VueGtag, {
  config: { 
    id: "G-KSF1W9NN9X",
  },
}, router)
app.use(pinia)
app.use(vuetify)
app.use(VSwatches)
app.component("timeago", Timeago)
app.component(Skeletor.name, Skeletor);
app.config.globalProperties.$http = AxiosCreate
app.config.globalProperties.$api = async (payload) => {
      return (await AxiosCreate.post("", JSON.stringify(payload))).data
}

app.component("v-select", vSelect)

app.mixin({
    methods: {
        levelIcon(level) {
          switch (true) {
            case level < 14 : return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 856.79 856.79"><g id="Calque_2" data-name="Calque 2"><g id="Layer_1" data-name="Layer 1"><path d="M428.39,0C192.18,0,0,192.18,0,428.39s192.18,428.4,428.39,428.4,428.4-192.18,428.4-428.4S664.61,0,428.39,0Zm0,107.31c161.68,0,295.76,120.13,317.83,275.81H582C562.4,316.8,501,268.25,428.4,268.25s-134,48.55-153.59,114.87H110.57C132.64,227.44,266.72,107.31,428.39,107.31Zm0,397.76a76.68,76.68,0,1,1,76.67-76.68A76.77,76.77,0,0,1,428.4,505.07ZM110.54,473.5H274.76A160.74,160.74,0,0,0,385.19,582.57V746.48C243.29,727.3,130.55,615.14,110.54,473.5ZM475.57,746V581.44A160.82,160.82,0,0,0,582,473.5H746.25C726.42,613.82,615.61,725.27,475.57,746Z"/></g></g></svg>'
            case level < 29 : return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 856.79 856.79"><g id="Calque_2" data-name="Calque 2"><g id="Layer_1" data-name="Layer 1"><path d="M433.25,239.53,473.63,364H606.06C580.23,292.83,512.73,241.45,433.25,239.53ZM250.8,364H378.23l40.39-124.29C341.35,243.59,276.13,294.25,250.8,364Zm0,0H378.23l40.39-124.29C341.35,243.59,276.13,294.25,250.8,364ZM433.25,239.53,473.63,364H606.06C580.23,292.83,512.73,241.45,433.25,239.53Zm0,0L473.63,364H606.06C580.23,292.83,512.73,241.45,433.25,239.53ZM250.8,364H378.23l40.39-124.29C341.35,243.59,276.13,294.25,250.8,364Zm0,0H378.23l40.39-124.29C341.35,243.59,276.13,294.25,250.8,364ZM433.25,239.53,473.63,364H606.06C580.23,292.83,512.73,241.45,433.25,239.53Zm0,0L473.63,364H606.06C580.23,292.83,512.73,241.45,433.25,239.53ZM250.8,364H378.23l40.39-124.29C341.35,243.59,276.13,294.25,250.8,364ZM428.4,0C192.22,0,0,192.15,0,428.39s192.22,428.4,428.4,428.4,428.39-192.22,428.39-428.4S664.64,0,428.4,0Zm47.16,746V611.41A188.3,188.3,0,0,0,530.93,587L426,510.73,323.29,585.37a188.45,188.45,0,0,0,61.94,27V746.48c-141.92-19.19-254.66-131.36-274.64-273H244.88a189.8,189.8,0,0,0,64.71,101.75l39.18-120.52-103-74.84c-.29,1.07-.57,2.14-.86,3.21H110.59c22-155.69,156.19-275.78,317.81-275.78S724.15,227.4,746.27,383.09H611.91q-.75-3.1-1.71-6.21L503.1,454.72,543.27,578.3a189.46,189.46,0,0,0,68.64-104.81H746.27C726.43,613.77,615.62,725.22,475.56,746ZM433.25,239.53,473.63,364H606.06C580.23,292.83,512.73,241.45,433.25,239.53ZM250.8,364H378.23l40.39-124.29C341.35,243.59,276.13,294.25,250.8,364Zm0,0H378.23l40.39-124.29C341.35,243.59,276.13,294.25,250.8,364ZM433.25,239.53,473.63,364H606.06C580.23,292.83,512.73,241.45,433.25,239.53Zm0,0L473.63,364H606.06C580.23,292.83,512.73,241.45,433.25,239.53ZM250.8,364H378.23l40.39-124.29C341.35,243.59,276.13,294.25,250.8,364Zm0,0H378.23l40.39-124.29C341.35,243.59,276.13,294.25,250.8,364ZM433.25,239.53,473.63,364H606.06C580.23,292.83,512.73,241.45,433.25,239.53Zm0,0L473.63,364H606.06C580.23,292.83,512.73,241.45,433.25,239.53ZM250.8,364H378.23l40.39-124.29C341.35,243.59,276.13,294.25,250.8,364Z"/></g></g></svg>'
            case level < 44 : return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 856.79 856.79"><g id="Calque_2" data-name="Calque 2"><g id="Layer_1" data-name="Layer 1"><path d="M428.4,0C192.18,0,0,192.18,0,428.39s192.18,428.4,428.4,428.4,428.39-192.18,428.39-428.4S664.61,0,428.4,0Zm47.19,746V578.36l-44.17-23.55-46.23,24.55V746.48c-147-19.87-262.74-139.55-276.45-288.42H300.42l-80.91-90.4H113.15c28.48-148.1,159-260.35,315.25-260.35S715.16,219.56,743.64,367.66H642.41L557,458.06h191C734.47,605.58,620.72,724.5,475.59,746Z"/><polygon points="620.17 352.46 489.81 340.26 431.38 216.68 371.58 340.05 241.87 352.6 330.56 451.71 313.93 585.78 431.45 523.42 548.75 585.92 526.63 451.5 620.17 352.46"/></g></g></svg>'
            case level < 59 : return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 813.83 941.21"><g id="Calque_2" data-name="Calque 2"><g id="Layer_1" data-name="Layer 1"><path d="M618.31,186.67l-6.82,7.2L547.35,262l.31,1.9c80.28,41.79,139.66,118.39,158.18,209.64-92.42-30.78-193.49-47.71-299.42-47.71-105.53,0-206.21,16.78-298.37,47.34,18-88,73.92-162.29,150-204.95l.76-6.07-66-73.69C77.1,260.21,0,388.4,0,534.26c0,224.4,182.55,407,407,407s406.88-182.55,406.88-407C813.83,387.27,735.44,258.16,618.31,186.67ZM103.79,568.33c44.05-23.79,83-31.3,108.86-33.31,11.82-.91,18.42,13.19,10.46,21.91-30.58,33.27-73,90.9-89.2,113.27A302.36,302.36,0,0,1,103.79,568.33ZM407,839.25A304.16,304.16,0,0,1,190.2,748.66l.46-.31c.61-.53,1.29-1.06,2-1.59,40.34-40.18,79-67.85,115.46-85.82a222.77,222.77,0,0,1,196.81,0c36.46,18,75.13,45.64,115.46,85.82.68.53,1.29,1.06,2,1.59l1,.64A304,304,0,0,1,407,839.25ZM679.56,670.93c-15.79-21.83-58.76-80.37-89.68-114-8-8.72-1.36-22.82,10.39-21.91,26.12,2,65.35,9.62,109.73,33.74A302.79,302.79,0,0,1,679.56,670.93Z"/><path d="M226.69,169.45h0l71.49,79.83h0l.36.44L280.88,392.24l124.86-66.33,124.63,66.41-23.5-142.75,2.48-2.64h0L584,167.87h0l0,0,22.29-23.57-138.51-13L405.66,0,342.13,131.15,204.31,144.49l22.36,24.95Z"/></g></g></svg>'
            case level < 74 : return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 842.52 842.52"><g id="Calque_2" data-name="Calque 2"><g id="Layer_1" data-name="Layer 1"><path d="M421.26,0C188.58,0,0,188.58,0,421.26S188.58,842.52,421.26,842.52,842.52,653.94,842.52,421.26,653.94,0,421.26,0Zm224,655.91L426.38,516.82l-72.55,53.9L567.52,711A323.5,323.5,0,0,1,259,702.25L334.83,450.1l-71.51-55.27L184.59,643.16A323.89,323.89,0,0,1,106.3,342.6l271-1,31.93-88.13-262.61.15-4,1.26c52.32-87.29,144.47-148,251.15-157l92.89,242.53H577L490.52,104.12c103.46,22.58,188.65,94.57,229.42,190L520.33,446.86,546,533.53,744,386.51a327,327,0,0,1,1.88,34.75C745.91,513.47,707.21,596.76,645.27,655.91Z"/></g></g></svg>'
            case level < 89 : return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 856.86 856.79"><g id="Calque_2" data-name="Calque 2"><g id="Layer_1" data-name="Layer 1"><path d="M428.43,0C192.21,0,0,192.18,0,428.39s192.17,428.4,428.39,428.4,428.4-192.18,428.4-428.4S664.65,0,428.43,0Zm0,749.47c-177,0-321.08-144-321.08-321.08s144-321.08,321.08-321.08,321.08,144,321.08,321.08S605.47,749.47,428.43,749.47Z"/><path d="M29.9,271,155.83,258.9A321.79,321.79,0,0,1,351,116.76L407.42.46C235.82,8.81,90.33,118.62,29.9,271ZM533.57,731.67a320.85,320.85,0,0,1-211.42-.43L204.71,793.53a427.93,427.93,0,0,0,446.3.72ZM839.31,306.92,748.55,403c.64,8.34,1,16.76,1,25.25A319.84,319.84,0,0,1,671.63,637.7l21,127.65c100-78.56,164.25-200.43,164.25-337.07A426.42,426.42,0,0,0,839.31,306.92ZM827,271.1C766.46,118.19,620.33,8.17,448,.46L502.6,115.91A322.07,322.07,0,0,1,701.31,259.32ZM107.38,428.28c0-5.85.15-11.63.5-17.33l-91-101.82A426.9,426.9,0,0,0,0,428.28C0,564.14,63.57,685.44,162.61,764l16.55-133.57A319.44,319.44,0,0,1,107.38,428.28Z"/><path d="M795,303.78,542.63,280.09,429.32,40.63l-115.94,239L61.86,304,233.53,495.93l-32.25,260L429.54,634.85,656.72,755.93,613.91,495.5ZM429.07,524.17,322.28,580.84,337.39,459l-80.6-90.06,117.88-11.41L429,245.42l53.11,112.3,118.46,11.09-85,90L535.67,581Z"/></g></g></svg>'
            case level < 100 : return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 856.86 856.22"><g id="Calque_2" data-name="Calque 2"><g id="Layer_1" data-name="Layer 1"><path d="M29.9,270.57l125.93-12.13A321.79,321.79,0,0,1,351,116.3L407.42,0C235.82,8.35,90.33,118.16,29.9,270.57ZM533.57,731.21a320.85,320.85,0,0,1-211.42-.43L204.71,793.07a427.93,427.93,0,0,0,446.3.72ZM839.31,306.46l-90.76,96.11c.64,8.34,1,16.76,1,25.25a319.84,319.84,0,0,1-77.92,209.42l21,127.65c100-78.56,164.25-200.43,164.25-337.07A426.42,426.42,0,0,0,839.31,306.46ZM827,270.64C766.46,117.73,620.33,7.71,448,0L502.6,115.45A322.07,322.07,0,0,1,701.31,258.86ZM107.38,427.82c0-5.85.15-11.63.5-17.33l-91-101.82A426.9,426.9,0,0,0,0,427.82C0,563.68,63.57,685,162.61,763.53L179.16,630A319.44,319.44,0,0,1,107.38,427.82Z"/><path d="M793.22,303.32,540.84,279.63,427.54,40.17l-116,239L60.08,303.53,231.75,495.47l-32.25,260L427.75,634.39,654.94,755.47,612.12,495ZM427.32,534.85,309.81,597.21l16.62-134.07L237.74,364l129.72-12.56,59.79-123.37,58.44,123.58,130.36,12.2-93.54,99,22.12,134.43Z"/></g></g></svg>'
            case level == 100 : return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 856.86 856.22"><g id="Calque_2" data-name="Calque 2"><g id="Layer_1" data-name="Layer 1"><path d="M29.9,270.57l125.93-12.13A321.79,321.79,0,0,1,351,116.3L407.42,0C235.82,8.35,90.33,118.16,29.9,270.57ZM533.57,731.21a320.85,320.85,0,0,1-211.42-.43L204.71,793.07a427.93,427.93,0,0,0,446.3.72ZM839.31,306.46l-90.76,96.11c.64,8.34,1,16.76,1,25.25a319.84,319.84,0,0,1-77.92,209.42l21,127.65c100-78.56,164.25-200.43,164.25-337.07A426.42,426.42,0,0,0,839.31,306.46ZM827,270.64C766.46,117.73,620.33,7.71,448,0L502.6,115.45A322.07,322.07,0,0,1,701.31,258.86ZM107.38,427.82c0-5.85.15-11.63.5-17.33l-91-101.82A426.9,426.9,0,0,0,0,427.82C0,563.68,63.57,685,162.61,763.53L179.16,630A319.44,319.44,0,0,1,107.38,427.82Z"/><path d="M793.22,303.32,540.84,279.63,427.54,40.17l-116,239L60.08,303.53,231.75,495.47l-32.25,260L427.75,634.39,654.94,755.47,612.12,495Z"/></g></g></svg>'
          }
        },
        mpstokmh(mps) {
            return Math.floor(mps * 3.6)
        },
        mpstomph(mps) {
          return Math.floor(mps * 2.236934)
        },
        carClasshHash(rating) {
            return carClasshHash(rating)
        },
        formatDate(e) {
          return new Date(Date.parse(e)).toLocaleDateString(window.navigator.language, {hour: '2-digit', minute:'2-digit'})
        },
        msToHMS( s ) {
            function pad(n, z) {
                z = z || 2
                return ('00' + n).slice(-z)
            }
        
            var ms = s % 1000
            s = (s - ms) / 1000
            var secs = s % 60
            s = (s - secs) / 60
            var mins = s % 60
            var hrs = (s - mins) / 60
            
            if(hrs > 0)
                return pad(hrs) + ':' + pad(mins) + ':' + pad(secs) + '.' + pad(ms, 3)
            else
                return pad(mins) + ':' + pad(secs) + '.' + pad(ms, 3)
        },
        number_format(number) {
          return Intl.NumberFormat('en-US').format(parseInt(number))
        }
    }
})

// Mount the app once
const vm = app.mount('#app')

// Configuration de la détection de mise à jour
const checkForAppUpdates = () => {
  checkForUpdates(() => {
    if (vm.$refs.updateNotice) {
      vm.$refs.updateNotice.showNotice()
    }
  })
}

// Vérifier les mises à jour toutes les 30 minutes
setInterval(checkForAppUpdates, 1800000)

// Premier check après 1 minute
setTimeout(checkForAppUpdates, 60000)

export { app }